import { useMutation } from '@apollo/react-hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import theme from '@jetshop/ui/utils/theme';
import React, { useContext } from 'react';
import styled from 'react-emotion';
import { addToCart } from '../../Cart/addToCart.gql';
import { OnAddToCart } from '../../ProductPage/AddToCart/AddToCartForm';

const BuyButton = styled('button')`
  background: ${theme('colors.buy')};
  text-transform: uppercase;
  font-family: 'Abel', sans-serif;
  font-size: 1.3rem;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 54px; */
  color: white;
  padding: 0.5rem 1rem;
  width: 100%;
  flex-shrink: 0;
  align-self: stretch;
`;

const CartIcon = styled(FontAwesomeIcon)``;

export const SharedCartBuyButton = ({ product, quantity }) => {
  const { cartId, setCartId } = useContext(CartIdContext);
  const { articleNumber } = product;

  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: quantity,
      },
    },
    onCompleted: (data) => addToCartSuccess({ cartId, setCartId })({ data }),
  });

  return (
    <OnAddToCart onClick={add}>
      {(props) => (
        <BuyButton
          onClick={() => {
            add();
            props.showTarget(true);
          }}
        >
          <CartIcon icon={['fal', 'shopping-cart']} />
        </BuyButton>
      )}
    </OnAddToCart>
  );
};
